import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulProducts,
    addSinglePrintfulProducts,
    updateSinglePrintfulProducts,
    getSinglePrintfulProducts,
    getAllPrintfulProducts,
    searchPrintfulProducts,
    searchPrintfulProductsWithSearchCriteria,
    preparePrintfulProductsList
}

const collectionName = 'printful-products';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulProducts = (printfulProducts) => {
    return Promise.map(printfulProducts, async printfulProducts => {
        await addSinglePrintfulProducts(printfulProducts);
    });
}

const addSinglePrintfulProducts = (printfulProducts) => {
    printfulProducts.createdAt = new Date();
    printfulProducts.updatedAt = printfulProducts.createdAt;
    return addDoc(collectionReference, printfulProducts);
}

const updateSinglePrintfulProducts = (printfulProducts) => {
    console.log('updateSinglePrintfulProducts', printfulProducts);

    const documentReference = doc(fireStoreDB, collectionName, printfulProducts.id);
    printfulProducts.updatedAt = new Date();
    return setDoc(documentReference, printfulProducts);
}

const getSinglePrintfulProducts = async (printfulProductsId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulProductsId);
    const printfulProductsDoc = await getDoc(documentReference);
    return prepareSinglePrintfulProducts(printfulProductsDoc);
}

const getAllPrintfulProducts = async () => {
    let searchQuery = query(collectionReference);
    const printfulProductsResult = await getDocs(searchQuery);
    return preparePrintfulProductsList(printfulProductsResult);
}

const searchPrintfulProducts = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductsResult = await getDocs(searchQuery);
    return preparePrintfulProductsList(printfulProductsResult);
}

const searchPrintfulProductsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulProductsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductsResult = await getDocs(searchQuery);
    return preparePrintfulProductsList(printfulProductsResult);
}

const preparePrintfulProductsList = (printfulProductsResult) => {
    const printfulProductsList = [];

    _.forEach(printfulProductsResult.docs, printfulProductsDoc => {
        printfulProductsList.push(prepareSinglePrintfulProducts(printfulProductsDoc));
    });

    return printfulProductsList;
}


const prepareSinglePrintfulProducts = (printfulProductsDoc) => {
    const printfulProducts = printfulProductsDoc.data();
    printfulProducts.id = printfulProductsDoc.id;
    return printfulProducts;
}
